// Contratto di sicurezza della sandbox HTML degli artefatti PA (Task #3817).
//
// Invariante NON negoziabile: gli script degli artefatti HTML girano in un
// iframe `sandbox` SENZA `allow-same-origin`. Con `srcDoc` + sandbox l'iframe
// ottiene un'origine opaca: cookie, sessione, localStorage e DOM della finestra
// parent sono inaccessibili per policy same-origin del browser. Aggiungere
// `allow-same-origin` insieme a `allow-scripts` annullerebbe l'isolamento
// (l'iframe erediterebbe l'origine dell'app): vietato e coperto da test.

export const HTML_SANDBOX_TOKENS = [
  'allow-scripts',
  'allow-forms',
  'allow-modals',
  'allow-popups',
] as const;

/** Valore dell'attributo `sandbox` degli iframe artefatto HTML. */
export const HTML_SANDBOX_ATTR: string = HTML_SANDBOX_TOKENS.join(' ');

/** Token che romperebbero l'isolamento: mai ammessi. */
export const FORBIDDEN_SANDBOX_TOKENS = [
  'allow-same-origin',
  'allow-top-navigation',
  'allow-top-navigation-by-user-activation',
  'allow-top-navigation-to-custom-protocols',
  'allow-popups-to-escape-sandbox',
  'allow-storage-access-by-user-activation',
] as const;

/**
 * `true` solo se l'attributo sandbox garantisce l'isolamento: nessun token
 * vietato e solo token della whitelist. Usato come guardia fail-closed dal
 * viewer (se violato NON monta l'iframe) e dai test bloccanti.
 */
export function isSandboxIsolated(sandboxAttr: string): boolean {
  const tokens = sandboxAttr.split(/\s+/).filter(Boolean);
  if (tokens.length === 0) return true; // sandbox="" = tutto vietato: massimo isolamento
  const allowed = new Set<string>(HTML_SANDBOX_TOKENS);
  const forbidden = new Set<string>(FORBIDDEN_SANDBOX_TOKENS);
  for (const t of tokens) {
    if (forbidden.has(t)) return false;
    if (!allowed.has(t)) return false;
  }
  return true;
}
